import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { PersonUsesBook } from '@lyceo/lyceo-pupil-app/practise/util-models';
import {
  selectLatestLoaded,
  selectPersonUsesBookByScopeId,
} from './person-uses-book.selectors';

@Injectable({
  providedIn: 'root',
})
export class PersonUsesBookFacade {
  private readonly store: Store = inject(Store);

  public readonly latestLoaded: Signal<boolean> =
    this.store.selectSignal(selectLatestLoaded);

  public personUsesBookByScopeId: (
    scopeId: string,
  ) => Signal<PersonUsesBook | undefined> = (scopeId: string) =>
    this.store.selectSignal(selectPersonUsesBookByScopeId(scopeId));
}
